module.exports = __webpack_public_path__ + "c88ef624f9fbc53a8bed6d3498d734.png";